export default __webpack_public_path__ + "static/media/alert.6110e8c5.svg";